exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".installation-title{margin-bottom:8px;color:#1f2326;color:var(--ring-text-color);font-size:48px;font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Droid Sans,Helvetica Neue,Arial,sans-serif;font-family:var(--ring-font-family);color:#222;line-height:64px;font-weight:200}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/blocks/installation-title/installation-title.scss
// module id = 849
// module chunks = 0